/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {NavLink} from "react-router-dom";


import {Col, Row} from "react-bootstrap";


import TERMINAL_INTERFACE from "@Services/Application/Interfaces/Terminals/Terminal";


type TerminalProps = {
    TERMINAL: TERMINAL_INTERFACE;
    TERMINALS_LIST_TYPE?: "TERMINALS" | "FAVORITE_TERMINALS" | "DISPOSITIONS" | "MONITORY_NOTES";
};


export const TerminalsListTerminalComponent: React.FC<TerminalProps> = ({
    TERMINAL, TERMINALS_LIST_TYPE = "TERMINALS"
}): JSX.Element | null => {


    if (!TERMINAL) return null;


    let TERMINAL_URL: string | null = "/bazy-paliw";

    switch (TERMINALS_LIST_TYPE) {
        case "DISPOSITIONS":
            TERMINAL_URL = "/dyspozycje/" + TERMINAL.TerminalNo;
            break;
        case "MONITORY_NOTES":
            TERMINAL_URL = "/awizacje/terminale/" + TERMINAL.TerminalNo;
            break;
        case "FAVORITE_TERMINALS":
            break;
    }

    return (
        <Col xs={12} className={"terminals-list-terminal-component terminals-list-terminal content-items-list-element"}>
            <Row as={NavLink} to={{pathname: TERMINAL_URL, state: {terminalName: TERMINAL.TerminalName}}} title={TERMINAL.TerminalName} className={"terminals-list-terminal-content content-items-list-element-content"}>

                {!!TERMINAL?.TerminalName &&
	            <Col xs={6} className={"terminal-name"}>
		            <span>{TERMINAL?.TerminalName}</span>
	            </Col>
                }

                <Col xs={TERMINALS_LIST_TYPE === "TERMINALS" ? 6 : {span: 3, offset: 3}} className={"terminal-information-component terminal-information"}>
                    <Row className={"terminal-information-content"}>

                        {TERMINALS_LIST_TYPE === "TERMINALS" &&
                        <Col xs={"auto"} title={`Liczba transp. oczekujących na przedłożenie`} className={"terminal-single-information waiting-for-submit-transports-information"}>
                            <span>{TERMINAL?.TransportWaitForSubmitCount || 0}</span>
                        </Col>
                        }

                        {TERMINALS_LIST_TYPE === "TERMINALS" &&
                        <Col xs={"auto"} title={`Liczba transp. oczekujących na wjazd`} className={"terminal-single-information waiting-for-entry-transports-information"}>
                            <span>{TERMINAL?.TransportWaitForEntryCount || 0}</span>
                        </Col>
                        }

                        {TERMINALS_LIST_TYPE === "TERMINALS" &&
                        <Col xs={"auto"} title={`Liczba transp. w trakcie załadunku`} className={"terminal-single-information active-transports-information"}>
                            <span>{TERMINAL?.TransportOpenedCount}</span>
                        </Col>
                        }

                        <Col xs={"auto"} title={`Liczba moich dyspozycji`} className={"terminal-single-information my-dispositions-information"}>
                            <span>{TERMINAL?.DispCount}</span>
                        </Col>

                        <Col xs={"auto"} title={`Liczba moich awizacji`} className={"terminal-single-information my-monitory-notes-information"}>
                            <span>{TERMINAL?.TransportNotificationCount}</span>
                        </Col>

                    </Row>
                </Col>

            </Row>

        </Col>
    );

};


export default TerminalsListTerminalComponent;
